import { component } from "preact";
import { css } from "emotion";

const H5 = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  semiBold = true,
  breakpoint = 600,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  children
}) => {
  const style = css({
    fontWeight: semiBold ? 600 : 500,
    fontSize: 16,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom
  });

  return <h5 className={style}>{children}</h5>;
};

export default H5;
